import React from 'react';
import { ContentList, ContentListItem } from '../../../_lib/components/ContentList';
import { murmurhash } from '../../../lib/js/hash';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type PageMembershipMatchingAttributesListProps = {
  matchingAttributes: string[] | undefined;
};

export function PageMembershipMatchingAttributesList({
  matchingAttributes,
}: PageMembershipMatchingAttributesListProps) {
  const { t } = useSonTranslation('PageMembershipMatchingAttributes');
  return (
    matchingAttributes && matchingAttributes.length > 0
      ? (
          <ContentList>
            {matchingAttributes.map(matchingAttribute => (
              <ContentListItem key={murmurhash(matchingAttribute)} modifier="padding-10-top-bottom">
                <p className="font-regular-15-21">{matchingAttribute}</p>
              </ContentListItem>
            ))}
          </ContentList>
        )
      : (
          <ContentMessage text={t('noPageMembershipMatchingAttributes')} />
        )
  );
}
